'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

/**
 * Basic button acting as a link
 *
 * @param {String}   type: type of button [big]
 * @param {String}   link: Link
 * @param {Array}    children: children of this button, usually text
 * @param {String}   className: additional classnames for button
 * @param {Boolean}  disabled: show button as disabled
 * @param {string|Function}   message: message id. If supplied, creates a message with the id.
 * */
const OTLinkButton = ({
  type,
  link,
  children,
  className,
  disabled = false,
  message,
  color,
  style,
  target,
}) => {
  let _color = color ? `ot-button--${color}` : null;
  let _message = null;
  if (message) {
    _message =
      typeof message === 'function' ? (
        <FormattedMessage id={message()} />
      ) : (
        <FormattedMessage id={message} />
      );
  }
  return (
    <a
      role="button"
      style={style}
      className={classnames(
        'ot-button',
        {
          'ot-button--disabled': disabled === true,
          'ot-button--big': type === 'big',
          [_color]: _color != null,
        },
        className
      )}
      href={link}
      target={target}
    >
      {children}
      {_message}
    </a>
  );
};

export default OTLinkButton;
